import { T } from "@/locales";

export default [
  {
    title: T("序号"),
    dataIndex: "index",
    fixed: "left",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
    fixed: "left",
    width: 240,
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
    width: 180,
  },
  {
    title: T("货品条码"),
    dataIndex: "material_barcode",
  },
  {
    title: T("入库短驳计费单位"),
    dataIndex: "stock_in_transport_charge_unit_display",
  },
  {
    title: T("入库短驳单价(元)"),
    dataIndex: "stock_in_transport_unit_price",
  },
  {
    title: T("入库装卸计费单位"),
    dataIndex: "stock_in_handling_charge_unit_display",
  },
  {
    title: T("入库装卸单价(元)"),
    dataIndex: "stock_in_handling_unit_price",
  },

  {
    title: T("出库短驳计费单位"),
    dataIndex: "stock_out_transport_charge_unit_display",
  },
  {
    title: T("出库短驳单价(元)"),
    dataIndex: "stock_out_transport_unit_price",
  },
  {
    title: T("出库计费单位"),
    dataIndex: "stock_out_handling_charge_unit_display",
  },
  {
    title: T("出库单价(元)"),
    dataIndex: "stock_out_handling_unit_price",
  },
  {
    title: T("仓储计费单位"),
    dataIndex: "storage_charge_unit_display",
  },
  {
    title: T("仓储单价(元)"),
    dataIndex: "storage_unit_price",
  },
  {
    title: T("操作"),
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    fixed: "right",
    width: 100,
  },
];
